import { render, staticRenderFns } from "./Vertraege.vue?vue&type=template&id=7b485358&scoped=true"
import script from "./Vertraege.vue?vue&type=script&lang=js"
export * from "./Vertraege.vue?vue&type=script&lang=js"
import style0 from "./Vertraege.vue?vue&type=style&index=0&id=7b485358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b485358",
  null
  
)

export default component.exports